import { Injectable } from "@angular/core";
import {
  AppFlow,
  defaultAppFlow,
  RouteSequence,
  loginAppFlow,
  formPostOrderB2C,
  formPostNoOrderB2C,
  formPostPrePopulatedOrder,
  loginAppFlowPrePopulated,
  automaticLoginAppFlow,
  formPostPrePopulatedOrderTechSupportFlow,
  formPostOrderB2CTechSupportFlow,
} from "./app-flow.model";

@Injectable({
  providedIn: "root",
})
export class AppFlowService {
  private active: AppFlow = defaultAppFlow;
  private availableAppFlow: AppFlow[] = [
    defaultAppFlow,
    loginAppFlow,
    formPostOrderB2C,
    formPostNoOrderB2C,
    formPostPrePopulatedOrder,
    loginAppFlowPrePopulated,
    automaticLoginAppFlow,
    formPostPrePopulatedOrderTechSupportFlow,
    formPostOrderB2CTechSupportFlow,
  ];
  activeStepId = 0;

  getAvailableAppFlow() {
    return this.availableAppFlow;
  }
  getActiveAppFlow(): AppFlow {
    return this.active;
  }

  setAppFlowByName(name: string): void {
    const flow = this.availableAppFlow.find((f) => f.name === name);
    if (flow) this.setActiveAppFlow(flow);
    else console.error(`App flow : ${name} does not found, reverting to default one: defautFlow`);
  }

  setActiveAppFlow(flow: AppFlow) {
    this.active = flow;
  }

  canActivatePath(path): boolean {
    return !!this.active.sequence.find((s) => s.path === path);
  }

  getRouteSequence(): Array<RouteSequence> {
    return this.active.sequence;
  }
  findRouteFromSequence(path: string): RouteSequence {
    return this.getRouteSequence().find((s) => s.path === path);
  }
  getActiveId(sequenceName: string): number {
    return this.active.sequence
      .map(function (e) {
        return e.path;
      })
      .indexOf(sequenceName);
  }
}
